import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	editRelease: {
		id: 'calendar.calendar-renderer.event-renderer.version-renderer.edit-release-item.edit-release',
		defaultMessage: 'Edit release',
		description: 'The dropdown option text of editing this release',
	},
});
